import React from 'react';
import { Divider, Grid } from '@material-ui/core';
import clsx from 'clsx';
import { FaChevronCircleLeft } from 'react-icons/fa';
import { useWindowSize } from '../../../hooks/windowSize';
import { useStyles } from './styles';

interface IMobileDashboard {
  showMobileContent: () => void;
}

const MobileDashboard: React.FC<IMobileDashboard> = ({
  showMobileContent,
  children,
}) => {
  const classes = useStyles();
  const size = useWindowSize();

  return (
    <Grid
      item
      xs={12}
      sm={8}
      className={clsx(classes.bottomContentMobile, {
        [classes.bottomContentMobileSm]:
          size.width && size.width < 960 && size.width > 600,
        [classes.bottomContentMobileXs]: size.width && size.width <= 600,
      })}
    >
      <div className={classes.dividerContainer}>
        <Divider
          variant="fullWidth"
          orientation="horizontal"
          style={{ height: 4, marginTop: 4, borderRadius: 3 }}
        />
      </div>
      <button
        type="button"
        onClick={showMobileContent}
        className={classes.floatingButtonMobile}
      >
        <FaChevronCircleLeft size={24} color="#7030A0" />
      </button>
      {children}
    </Grid>
  );
};

export default MobileDashboard;
